import { render, staticRenderFns } from "./EntityEventsIndexPage.vue?vue&type=template&id=78f534f7&"
import script from "./EntityEventsIndexPage.vue?vue&type=script&lang=js&"
export * from "./EntityEventsIndexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f534f7')) {
      api.createRecord('78f534f7', component.options)
    } else {
      api.reload('78f534f7', component.options)
    }
    module.hot.accept("./EntityEventsIndexPage.vue?vue&type=template&id=78f534f7&", function () {
      api.rerender('78f534f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/entity_events/EntityEventsIndexPage.vue"
export default component.exports